import React from 'react'
import { PageHeading } from '../../components/common/pageHeading/PageHeading'

import bg from '../../assests/images/inventory_bg.avif'
import { UserData } from '../../components/user/userData/UserData'

export const UserList = () => {
  return (
    <div className='mb-5'>
      <PageHeading title={'User List'} />
      <section className='container py-2'>
        <div className='row align-items-center'>
          <div className='col-12 col-md-6 text-center'>
            <h1 className='display-4'>Supply Corner</h1>
            <p className='lead'>User information</p>
            <a href='#' className='btn btn-outline-warning btn-lg'>
              Dashboard
            </a>
          </div>
          <div className='col-md-6'>
            <img src={bg} className='img-fluid rounded' alt='Business' />
          </div>
        </div>
      </section>
      <UserData />
    </div>
  )
}
